// import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// export interface ChatSession {
//     id: number;
//     header: string;
//     session_id: string;
//     created_at: string;
// }

// interface ChatSessionState {
//     loading: boolean;
//     error: string | null;
//     chatSessions: ChatSession[]; // <-- Changed to array to match response format
// }

// const initialState: ChatSessionState = {
//     loading: false,
//     error: null,
//     chatSessions: [],
// };

// const chatSessionHistorySlice = createSlice({
//     name: "chatSession",
//     initialState,
//     reducers: {
//         fetchChatSessionsRequest: (state) => {
//             state.loading = true;
//             state.error = null;
//         },
//         fetchChatSessionsSuccess: (state, action: PayloadAction<ChatSession[]>) => {
//             state.loading = false;
//             state.chatSessions = action.payload;
//         },
//         fetchChatSessionsFailure: (state, action: PayloadAction<string>) => {
//             state.loading = false;
//             state.error = action.payload;
//         },
//         clearChatSessions: (state) => {
//             state.chatSessions = [];
//         },
//     },
// });

// export const { fetchChatSessionsRequest, fetchChatSessionsSuccess, fetchChatSessionsFailure, clearChatSessions } =
//     chatSessionHistorySlice.actions;

// export const chatSessionHistoryReducer = chatSessionHistorySlice.reducer;
// export const chatSessionActionTypes = chatSessionHistorySlice.actions;

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ChatSession {
  id: number|string;
  header: string;
  session_id: string;
  created_at: string;
  updated_at: string;
}

interface ChatSessionState {
  loading: boolean;
  error: string | null;
  // history list (side menu)
  chatSessions: ChatSession[];

  // search results
  searchSessions: ChatSession[];

  // pagination
  count: number;
  next: string | null;
  previous: string | null;
}

const initialState: ChatSessionState = {
  loading: false,
  error: null,
  chatSessions: [],
  searchSessions: [],
  count: 0,
  next: null,
  previous: null,
};

const chatSessionHistorySlice = createSlice({
  name: 'chatSession',
  initialState,
  reducers: {
    fetchChatSessionsRequest: (
      state,
      _action: PayloadAction<{ offset: number; limit: number; search?: string; partnerProjectId?: string }>
    ) => {
      state.loading = true;
      state.error = null;
    },

    fetchChatSessionsSuccess: (
      state,
      action: PayloadAction<{
        count: number;
        next: string | null;
        previous: string | null;
        results: ChatSession[];
        offset: number;
        search: string | null;
      }>
    ) => {
      state.loading = false;

      const { results, offset, count, next, previous,search } = action.payload;
      if (search) {
        state.searchSessions = results;
      } else {
      if (offset === 0) {
        state.chatSessions = results;
      } else {
        state.chatSessions.push(...results);
      }}

      state.count = count;
      state.next = next;
      state.previous = previous;
    },

    fetchChatSessionsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    clearChatSessions: (state) => {
      state.chatSessions = [];
      state.count = 0;
      state.next = null;
      state.previous = null;
    },
  },
});

export const {
  fetchChatSessionsRequest,
  fetchChatSessionsSuccess,
  fetchChatSessionsFailure,
  clearChatSessions,
} = chatSessionHistorySlice.actions;

export const chatSessionHistoryReducer = chatSessionHistorySlice.reducer;